import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import {
  UntypedFormBuilder,
  UntypedFormGroup,
  Validators,
} from '@angular/forms';
import { Store } from '@ngrx/store';
import { InceptionService } from '@proximus/ng-common';
import {
  ApplicationState,
  getMailboxesErrorInfo,
  getMailboxesSuccessInfo,
} from '../../../store/reducers/index';
import * as MailboxesActions from '../../store/actions/mailbox.actions';
import { DefaultMailboxDomain } from '../../config/my-mail.config';
import { TechnicalError } from '../../models/errors.model';
import { LengthValidation } from '../../utils/length-validation';
import { filter } from 'rxjs/operators';

@Component({
  selector: 'mprd-create-mailbox-container',
  templateUrl: 'create-mailbox-container.component.html',
})
export class CreateMailboxContainerComponent implements OnInit {
  showLoadingSpinner: boolean;
  createMailboxForm: UntypedFormGroup;
  customLengthValidation = LengthValidation;
  destroy: Function;

  constructor(
    private builder: UntypedFormBuilder,
    private store: Store<ApplicationState>,
    private inceptionService: InceptionService,
    private router: Router,
  ) {}

  onPasswordFormStatusAndValue(passwordFormStatusAndValue: {
    passwordFormStatus: boolean;
    password: string;
  }) {
    passwordFormStatusAndValue.passwordFormStatus
      ? this.createMailboxForm.patchValue({
          password: passwordFormStatusAndValue.password,
        })
      : this.createMailboxForm.patchValue({ password: '' });
  }

  onMailIdFormStatusAndValue(mailIdFormStatusAndValue: {
    mailIdFormStatus: string;
    mailId: string;
  }) {
    mailIdFormStatusAndValue.mailIdFormStatus
      ? this.createMailboxForm.patchValue({
          mailId: mailIdFormStatusAndValue.mailId,
        })
      : this.createMailboxForm.patchValue({ mailId: '' });
  }

  createMailbox() {
    this.showLoadingSpinner = true;
    const newMailbox = {
      aliasId: `${this.createMailboxForm.get('mailId').value}@${DefaultMailboxDomain}`,
      password: this.createMailboxForm.get('password').value,
    };
    this.store.dispatch(new MailboxesActions.CreateAction(newMailbox));
    this.createMailboxForm.reset();
  }

  ngOnInit() {
    this.createMailboxForm = this.builder.group({
      password: ['', [Validators.required]],
      mailId: ['', [Validators.required]],
    });

    this.store
      .select(getMailboxesErrorInfo)
      .pipe(filter(Boolean))
      .subscribe((error: TechnicalError) => {
        this.showLoadingSpinner = false;
      });

    this.store
      .select(getMailboxesSuccessInfo)
      .pipe(filter(Boolean))
      .subscribe((state: any) => {
        if (state !== null) {
          this.showLoadingSpinner = false;
        }
      });

    this.inceptionService.stickyContainer(
      '#jsrs-stickyContainer [data-sticky-container]',
    );
  }

  onCancel() {
    this.destroy();
  }
}
